/* PawVibe – interacciones del tema (sin dependencias) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  // localStorage con respaldo en cookie (por si el navegador bloquea el almacenamiento)
  var storage = {
    get: function (k) {
      try { var v = window.localStorage.getItem(k); if (v !== null) return v; } catch (e) {}
      var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    },
    set: function (k, v) {
      try { window.localStorage.setItem(k, v); } catch (e) {}
      try { document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {}
    }
  };

  function str(key) { return (window.theme && window.theme.strings && window.theme.strings[key]) || ''; }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* ---------- Header con sombra al hacer scroll ---------- */
  function initHeader() {
    var header = $('[data-header]');
    var top = $('[data-scroll-top]');
    var onScroll = function () {
      var y = window.scrollY;
      if (header) header.classList.toggle('is-scrolled', y > 10);
      if (top) top.classList.toggle('is-visible', y > 800);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function initDrawers() {
    $$('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDrawer(document.getElementById(btn.getAttribute('data-drawer-open'))); });
    });
    $$('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeDrawer(btn.closest('.drawer')); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.drawer.is-open, .cart-drawer.is-open').forEach(closeDrawer);
    });
  }

  /* ---------- Carrito lateral ---------- */
  var cartDrawer;
  function renderCart(cart) {
    var items = $('#CartDrawerItems');
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = '<p class="cart-drawer__empty">' + str('cartEmpty') + '</p>';
    } else {
      items.innerHTML = cart.items.map(function (item, i) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        return '<div class="cart-item">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><p class="cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
          (item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
          '<div class="cart-item__qty"><button type="button" data-qty="' + (i + 1) + '" data-value="' + (item.quantity - 1) + '" aria-label="' + str('removeOne') + '">−</button><span>' + item.quantity + '</span><button type="button" data-qty="' + (i + 1) + '" data-value="' + (item.quantity + 1) + '" aria-label="' + str('addOne') + '">+</button></div></div>' +
          '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span></div>';
      }).join('');
    }
    var subtotal = $('#CartDrawerSubtotal');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    var ship = $('[data-free-shipping]');
    if (ship) {
      var threshold = parseInt(ship.getAttribute('data-free-shipping'), 10);
      var left = threshold - cart.total_price;
      $('[data-free-shipping-text]', ship).innerHTML = left > 0
        ? str('freeShippingLeft').replace('[amount]', formatMoney(left))
        : str('freeShippingDone');
      $('[data-free-shipping-bar]', ship).style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
    }
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function initCart() {
    cartDrawer = $('#CartDrawer');
    var useDrawer = document.body.getAttribute('data-cart-type') !== 'page';
    if (!cartDrawer || !useDrawer) return;

    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(cartDrawer); refreshCart(); });
    });
    $$('[data-cart-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(cartDrawer); }); });

    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.getAttribute('data-qty'), 10), quantity: Math.max(0, parseInt(btn.getAttribute('data-value'), 10)) })
      }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer(cartDrawer); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Rotador de anuncios ---------- */
  function initRotators() {
    $$('[data-rotator]').forEach(function (el) {
      var items = el.children;
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(el.getAttribute('data-interval'), 10) || 5000);
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (el) {
      var slides = $$('.slideshow__slide', el);
      var dots = $$('[data-slide-to]', el);
      if (slides.length < 2) return;
      var index = 0, timer = null;
      var interval = parseInt(el.getAttribute('data-interval'), 10) || 6000;
      var autoplay = el.getAttribute('data-autoplay') === 'true';

      function go(n) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }
      function play() { stop(); if (!el.classList.contains('is-paused')) timer = setInterval(function () { go(index + 1); }, interval); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      var prev = $('[data-slide-prev]', el), next = $('[data-slide-next]', el), pause = $('[data-slide-pause]', el);
      if (prev) prev.addEventListener('click', function () { go(index - 1); if (autoplay) play(); });
      if (next) next.addEventListener('click', function () { go(index + 1); if (autoplay) play(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); if (autoplay) play(); }); });
      if (pause) pause.addEventListener('click', function () {
        el.classList.toggle('is-paused');
        pause.setAttribute('aria-label', el.classList.contains('is-paused') ? str('play') : str('pause'));
        if (el.classList.contains('is-paused')) stop(); else play();
      });

      var startX = null;
      el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); if (autoplay) play(); }
        startX = null;
      });
      if (autoplay) play();
    });
  }

  /* ---------- Sliders con barra de progreso ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var bar = $('[data-slider-progress]', slider);
      if (!track || !bar) return;
      var progress = bar.parentElement;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) { progress.classList.add('is-hidden'); return; }
        progress.classList.remove('is-hidden');
        var ratio = track.clientWidth / track.scrollWidth;
        var width = progress.clientWidth * ratio;
        bar.style.width = width + 'px';
        bar.style.transform = 'translateX(' + ((progress.clientWidth - width) * (track.scrollLeft / max)) + 'px)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // Arrastrar con el mouse en escritorio
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; });
      track.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 5) moved = true; track.scrollLeft = sl - dx; });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Aparición al hacer scroll + contadores ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / 1600);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initReveal() {
    var targets = $$('.reveal, [data-count]');
    if (!('IntersectionObserver' in window)) { targets.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.hasAttribute('data-count')) animateCount(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Puntos interactivos ---------- */
  function initHotspots() {
    $$('[data-hotspot]').forEach(function (spot) {
      var btn = $('.hotspot__dot', spot);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !spot.classList.contains('is-open');
        $$('[data-hotspot].is-open').forEach(function (s) { s.classList.remove('is-open'); });
        spot.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open);
      });
    });
    document.addEventListener('click', function () { $$('[data-hotspot].is-open').forEach(function (s) { s.classList.remove('is-open'); }); });
  }

  /* ---------- Palabras animadas ---------- */
  function initWordRotators() {
    $$('[data-word-rotator]').forEach(function (el) {
      var words = $$('.word-rotator__word', el);
      if (words.length < 2) return;
      var i = 0;
      setInterval(function () {
        var current = words[i];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        setTimeout(function () { current.classList.remove('is-leaving'); }, 500);
        i = (i + 1) % words.length;
        words[i].classList.add('is-active');
      }, 2400);
    });
  }

  /* ---------- Cinta de descuento ---------- */
  function initRibbons() {
    $$('[data-ribbon]').forEach(function (ribbon) {
      if (storage.get('pv-ribbon-' + ribbon.id) === 'closed') ribbon.classList.add('is-hidden');
      var close = $('[data-ribbon-close]', ribbon);
      if (close) close.addEventListener('click', function () { ribbon.classList.add('is-hidden'); storage.set('pv-ribbon-' + ribbon.id, 'closed'); });
      var code = $('[data-copy]', ribbon);
      if (code) code.addEventListener('click', function () {
        code.classList.add('is-revealed');
        if (navigator.clipboard) navigator.clipboard.writeText(code.getAttribute('data-copy')).catch(function () {});
      });
    });
  }

  /* ---------- Popup ---------- */
  function initPopup() {
    var popup = $('[data-popup]');
    if (!popup || window.Shopify && window.Shopify.designMode) return;
    var last = parseInt(storage.get('pv-popup') || '0', 10);
    var days = parseInt(popup.getAttribute('data-days'), 10) || 7;
    if (last && Date.now() - last < days * 864e5) return;
    setTimeout(function () { popup.classList.add('is-open'); popup.setAttribute('aria-hidden', 'false'); }, parseInt(popup.getAttribute('data-delay'), 10) || 8000);
    $$('[data-popup-close]', popup).forEach(function (b) {
      b.addEventListener('click', function () { popup.classList.remove('is-open'); popup.setAttribute('aria-hidden', 'true'); storage.set('pv-popup', String(Date.now())); });
    });
  }

  /* ---------- Video pausa ---------- */
  function initVideos() {
    $$('[data-video-toggle]').forEach(function (btn) {
      var video = btn.parentElement.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;
    var main = $('[data-main-image]', root);
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-thumb'); main.removeAttribute('srcset'); }
        $$('[data-thumb]', root).forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', root);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      });
    });
    var json = $('[data-variants]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var selects = $$('[data-option-index]', root);
    var idInput = $('[name="id"]', root);
    var submit = $('[data-add-button]', root);
    var price = $('[data-price]', root);
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var values = selects.map(function (x) { return x.value; });
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); });
        if (!match) { submit.disabled = true; submit.textContent = str('unavailable'); return; }
        idInput.value = match.id;
        submit.disabled = !match.available;
        submit.textContent = match.available ? str('addToCart') : str('soldOut');
        if (price) price.innerHTML = '<span class="price' + (match.compare_at_price > match.price ? ' price--sale' : '') + '">' + formatMoney(match.price) + '</span>' + (match.compare_at_price > match.price ? '<s class="price price--compare">' + formatMoney(match.compare_at_price) + '</s>' : '');
        if (match.featured_image && main) { main.src = match.featured_image.src; main.removeAttribute('srcset'); }
        if (window.history.replaceState) window.history.replaceState({}, '', '?variant=' + match.id);
      });
    });
  }

  /* ---------- Idioma: selector y detección automática ---------- */
  // Busca el idioma de la tienda que mejor coincide con las preferencias del navegador.
  // Primero exacto (pt-BR = pt-BR), luego por idioma base (pt-PT → pt-BR, en-US → en).
  function matchLanguage(available, preferred) {
    var lower = available.map(function (c) { return c.toLowerCase(); });
    for (var i = 0; i < preferred.length; i++) {
      var pref = String(preferred[i] || '').toLowerCase();
      if (!pref) continue;
      var exact = lower.indexOf(pref);
      if (exact > -1) return available[exact];
      var base = pref.split('-')[0];
      for (var j = 0; j < lower.length; j++) {
        if (lower[j].split('-')[0] === base) return available[j];
      }
    }
    return null;
  }

  function switchLanguage(code) {
    var form = $('.lang-selector__form');
    if (!form) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'language_code';
    input.value = code;
    form.appendChild(input);
    form.submit();
  }

  function initLanguage() {
    // Cuando el visitante elige un idioma, se recuerda y nunca se vuelve a cambiar automáticamente
    $$('[data-lang-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () { storage.set('pv-lang', btn.value); });
    });
    // Cerrar el desplegable al hacer clic fuera
    document.addEventListener('click', function (e) {
      $$('.lang-selector__details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });

    var loc = window.theme && window.theme.localization;
    if (!loc || !loc.autoDetect || !loc.available || loc.available.length < 2) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;
    if (storage.get('pv-lang')) return; // ya se detectó o eligió antes

    var preferred = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    var match = matchLanguage(loc.available, preferred);
    storage.set('pv-lang', match || loc.current);
    if (match && match.toLowerCase() !== String(loc.current).toLowerCase()) switchLanguage(match);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLanguage();
    initHeader();
    initDrawers();
    initCart();
    initRotators();
    initSlideshows();
    initSliders();
    initReveal();
    initHotspots();
    initWordRotators();
    initRibbons();
    initPopup();
    initVideos();
    initProduct();
  });
})();
